import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDrawer } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { Session, SessionListItem } from 'app/models/copilot.model';
import { EventService } from 'app/services/event.service';
import { MatMenuModule } from '@angular/material/menu';
import { FuseConfirmationService } from '@fuse/services/confirmation';
import { RagService } from 'app/services/rag.service';
import { ToastrService } from 'ngx-toastr';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDividerModule } from '@angular/material/divider';
import { MatDialog } from '@angular/material/dialog';
import { SearchChatsComponent } from '../../file-manager/modal/search-chats/search-chats.component';

@Component({
  selector: 'app-copilot-drawer',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatMenuModule,
    MatButtonModule, MatTooltipModule, MatDividerModule
  ],
  templateUrl: './copilot-drawer.component.html',
  styleUrls: ['./copilot-drawer.component.scss']
})
export class CopilotDrawerComponent implements OnInit {

  constructor(
    private event_service: EventService,
    private _fuseConfirmationService: FuseConfirmationService,
    private _ragService: RagService,
    private dialog: MatDialog,
    private toastService: ToastrService,
  ) {
  }
  @Output() toggleDrawer = new EventEmitter();
  @Input() drawer: MatDrawer;
  @Input() theme: string;
  @Input() sessions: Session[] = [];
  @Input() selectedSessionId: string = null;
  @Input() userDetail: { name: string, email: string } = { name: 'User', email: '' };
  @Input() selectedAssetId: string = null;
  isHovering: boolean = false;
  hoverTimeout: any;
  @Input() drawerConfig = {
    opened: true,
    mode: 'side',
    collapse: true,
  }
  selectedMenuSessionId: string = null;
  isCollapsed: boolean = true;

  ngOnInit(): void {
  }

  selectSession(session: any) {
    this.event_service.changeCurrentAssetSession.emit(session);
  }

  closeDrawer() {
    this.drawer.close();
  }

  startNewChat() {
    this.event_service.newCopilotChat.emit();
  }

  shareSession(session: Session) {
    const dialogRef = this._fuseConfirmationService.open({
      title: 'Share Session',
      message: 'Are you sure you want to share this session?',
      icon: {
        show: true,
        name: 'heroicons_outline:share',
        color: 'primary'
      },
      actions: {
        confirm: {
          label: 'Share'
        },
        cancel: { label: 'Cancel' }
      },
      dismissible: true
    }
    );

  }

  renameSession() {
    const dialogRef = this._fuseConfirmationService.open({
      title: 'Rename Session',
      message: 'Are you sure you want to rename this session?',
      icon: {
        show: true,
        name: 'heroicons_outline:pencil-square',
        color: 'primary'
      },
      actions: {
        confirm: {
          label: 'Rename'
        },
        cancel: { label: 'Cancel' }
      },
      dismissible: true
    }
    );

  }

  archiveSession(session: Session) {
    const dialogRef = this._fuseConfirmationService.open({
      title: 'Archive Session',
      message: 'Are you sure you want to archive this session?',
      icon: {
        show: true,
        name: 'heroicons_outline:archive-box-arrow-down',
        color: 'primary'
      },
      actions: {
        confirm: {
          label: 'Archive'
        },
        cancel: { label: 'Cancel' }
      },
      dismissible: true
    }
    );
  }

  deleteSession(session: Session) {
    // Open the dialog and save the reference of it
    const dialogRef = this._fuseConfirmationService.open({
      title: 'Delete Session',
      message: 'Are you sure you want to delete this session? This action cannot be undone!',
      icon: {
        show: true,
        name: 'heroicons_outline:trash',
        color: 'warn'
      },
      actions: {
        confirm: {
          label: 'Delete'
        },
        cancel: { label: 'Cancel' }
      },
      dismissible: true
    }
    );

    //  // Subscribe to afterClosed from the dialog reference
    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'confirmed') {
        this._ragService.deleteSession(session.id).then((res) => {
          this.toastService.success('Session deleted successfully', 'Deleted');
          this.selectedSessionId = null;
          this.sessions = this.sessions.filter(s => s.id !== session.id);
          this.event_service.deleteCopilotAssetSession.emit(true);

        }).catch((err) => {
          console.error('Error deleting session:', err);
        });
      }
    });

  }

  onDrawerToggle() {
    this.drawerConfig.collapse = !this.drawerConfig.collapse;
  }

  onDrawerMouseEnter() {
    this.isHovering = true;
  }

  onDrawerMouseLeave(event: MouseEvent) {
    const target = event.currentTarget as HTMLElement;
    const related = event.relatedTarget as Node | null;

    // Check if we are going into a tooltip overlay
    const overlayContainer = document.querySelector('.cdk-overlay-container');
    if (related && overlayContainer?.contains(related)) {
      return; // ignore mouseleave caused by tooltip
    }

    // Normal leave check
    if (!related || !target.contains(related)) {
      this.hoverTimeout = setTimeout(() => {
        this.isHovering = false;
      }, 300);
    }
  }

  toggleCopilot(){
    this.toggleDrawer.emit();
  }

  openSearchChat() {
    const dialogRef = this.dialog.open(SearchChatsComponent, {
      data: {
        assetId: this.selectedAssetId,
      },
    });
    dialogRef.afterClosed().subscribe((selectedChat: SessionListItem) => {
      if (selectedChat) {
        this.selectSession(selectedChat);
      }
    });
  }
}
